import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigationItems = [
   
     { label: 'Home', path: '/', icon: 'Camera' },
    { label: 'Services', path: '/service', icon: 'Star' },
    { label: 'Book Session', path: '/service-booking', icon: 'Calendar' },
    { label: 'AI Mode', path: '/AiMode', icon: 'Brain' },
    { label: 'Photo Lab', path: '/Photolab', icon: 'Image' },
    { label: 'About', path: '/about', icon: 'User' },
   


  ];

  const isActivePath = (path) => {
    if (path === '/') {
      return location?.pathname === '/';
    }
    if (path === '/service') {
    return location.pathname === '/service' || location.pathname.startsWith('/service/');
  }
    return location?.pathname?.startsWith(path);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
<header 
  className={`fixed top-0 left-0 right-0 z-[1000] transition-all duration-300 ${
    isScrolled 
      ? 'bg-gray-900/60 backdrop-blur-sm shadow-md' 
      : 'bg-background'
  }`}
>
  <div className="w-full">
    <div className="flex items-center justify-between h-16 px-6 lg:px-8">
      
      {/* Logo */}
      <Link 
        to="/" 
        className="flex items-center space-x-2 transition-all hover:scale-105"
        onClick={closeMenu}
      >
        <div className="flex items-center space-x-3">
          <div className="w-9 h-9 bg-gradient-to-tr from-accent to-accent/80 rounded-full 
                          flex items-center justify-center shadow-md">
       <img src="https://marketplace.canva.com/EAGMaI2Vu7c/1/0/1600w/canva-black-yellow-illustrative-photography-logo-ol8q8m4IRbg.jpg" alt="logo" srcSet="" />
          </div>
          <div className="flex flex-col">
            <span className={`font-heading font-semibold text-lg leading-tight ${
              isScrolled ? 'text-white' : 'text-primary'
            }`}>
              Studio Musu
            </span>
            <span className={`font-caption text-xs leading-tight tracking-wide ${
              isScrolled ? 'text-gray-300' : 'text-muted-foreground'
            }`}>
              Photography
            </span>
          </div>
        </div>
      </Link>

      {/* Desktop Navigation */}
      <nav className="hidden md:flex items-center space-x-8">
        {navigationItems?.map((item) => (
          <Link
            key={item?.path}
            to={item?.path}
            className={`relative font-body font-medium text-sm transition-all duration-300 
                        hover:text-accent after:content-[''] after:absolute after:left-0 
                        after:-bottom-1 after:w-0 after:h-[2px] after:bg-accent 
                        after:transition-all after:duration-300 hover:after:w-full
                        ${
                          isActivePath(item?.path)
                            ? 'text-accent after:w-full'
                            : isScrolled
                              ? 'text-white'
                              : 'text-foreground'
                        }`}
          >
            {item?.label}
          </Link>
        ))}
      </nav>

      {/* Admin Access Button - Desktop */}
      <div className="hidden md:flex items-center space-x-4">
        <Link to="/admin">
          <Button 
            variant="outline" 
            size="sm"
            iconName="Settings"
            iconPosition="left"
            iconSize={16}
            className={`hover:shadow-md transition-all duration-300 ${
              isScrolled 
                ? 'border-white text-white hover:bg-accent hover:text-white' 
                : 'hover:bg-accent hover:text-white'
            }`}
          >
            Admin
          </Button>
        </Link>
      </div>

      {/* Mobile Menu Button */}
      <button
        onClick={toggleMenu}
        className="md:hidden p-2 rounded-lg hover:bg-muted transition-all duration-300"
        aria-label="Toggle menu"
      >
        <Icon 
          name={isMenuOpen ? "X" : "Menu"} 
          size={24} 
          color={isScrolled ? "#ffffff" : "var(--color-foreground)"} 
        />
      </button>
    </div>

    {/* Mobile Navigation */}
    {isMenuOpen && (
      <div className={`md:hidden border-t border-border animate-slide-in-from-top shadow-lg
                      ${isScrolled ? 'bg-gray-900/95' : 'bg-background/95 backdrop-blur-md'}`}>
        <nav className="px-6 py-4 space-y-4">
          {navigationItems?.map((item) => (
            <Link
              key={item?.path}
              to={item?.path}
              onClick={closeMenu}
              className={`flex items-center space-x-3 py-2 font-body font-medium transition-all duration-300 
                          hover:text-accent hover:translate-x-1
                          ${
                            isActivePath(item?.path)
                              ? 'text-accent'
                              : isScrolled
                                ? 'text-white'
                                : 'text-foreground'
                          }`}
            >
              <Icon name={item?.icon} size={20} color={isScrolled ? "#ffffff" : "var(--color-foreground)"} />
              <span>{item?.label}</span>
            </Link>
          ))}
          
          {/* Mobile Admin Access */}
          <div className="pt-4 border-t border-border">
            <Link 
              to="/admin"
              onClick={closeMenu}
              className={`flex items-center space-x-3 py-2 font-body font-medium transition-all duration-300
                         hover:text-accent hover:translate-x-1
                         ${isScrolled ? 'text-gray-300' : 'text-muted-foreground'}`}
            >
              <Icon name="Settings" size={20} color={isScrolled ? "#d1d5db" : "var(--color-foreground)"} />
              <span>Admin Dashboard</span>
            </Link>
          </div>
        </nav>
      </div>
    )}
  </div>
</header>

  );
};

export default Header;